import { useState } from "react";
import { Menu, X } from "lucide-react";
import { colors, font, maxWidth } from "../styles/theme";
import { contacts } from "../data/company";
import { useRequestModal } from "./ModalProvider";
import useSectionNav from "../lib/useSectionNav";

const NAV = [
  { label: "Услуги", id: "uslugi" },
  { label: "О компании", id: "about" },
  { label: "Объекты", id: "objects" },
  { label: "Контакты", id: "contacts" },
];

// Шапка. theme: "light" | "dark". visible управляет появлением по скроллу.
export default function Header({ theme = "light", visible = true }) {
  const dark = theme === "dark";
  const { openRequest } = useRequestModal();
  const [menuOpen, setMenuOpen] = useState(false);
  const { goToSection, goHome } = useSectionNav(() => setMenuOpen(false));

  const wrap = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    background: dark ? "rgba(13,13,16,.9)" : "rgba(255,255,255,.93)",
    backdropFilter: "saturate(150%) blur(12px)",
    WebkitBackdropFilter: "saturate(150%) blur(12px)",
    borderBottom: dark ? "1px solid rgba(255,255,255,.09)" : "1px solid #e6e9ee",
    boxShadow: dark ? "0 8px 30px rgba(0,0,0,.45)" : "0 8px 30px rgba(0,0,0,.07)",
    transition: "transform .5s cubic-bezier(.4,0,.2,1), opacity .4s ease",
    transform: visible ? "translateY(0)" : "translateY(-101%)",
    opacity: visible ? 1 : 0,
  };

  const linkColor = dark ? "#c7ccd3" : colors.ink2;
  const navHover = dark ? "#fff" : colors.red;

  return (
    <header className="site-header" style={wrap}>
      <div
        style={{
          maxWidth,
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          gap: 22,
          padding: "18px 22px",
        }}
      >
        <a href="/" onClick={goHome} style={{ display: "flex", alignItems: "center", gap: 11, textDecoration: "none", cursor: "pointer" }}>
          <img src="/logo-klimat.png" alt="ВК-КЛИМАТ" style={{ width: 46, height: 46, objectFit: "contain" }} />
          <div style={{ fontFamily: font.display, fontWeight: 700, fontSize: 26 }}>
            <span style={{ color: dark ? "#fff" : colors.ink }}>ВК</span>
            <span style={{ color: colors.red }}>-КЛИМАТ</span>
          </div>
        </a>

        <nav
          className="header-nav"
          style={{
            display: "flex",
            gap: 24,
            marginLeft: "auto",
            whiteSpace: "nowrap",
            fontFamily: font.display,
            fontWeight: 500,
            fontSize: 13.5,
            letterSpacing: ".04em",
            textTransform: "uppercase",
          }}
        >
          {NAV.map((l) => (
            <a
              key={l.label}
              href={"/#" + l.id}
              onClick={goToSection(l.id)}
              style={{ textDecoration: "none", color: linkColor, cursor: "pointer" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = navHover)}
              onMouseLeave={(e) => (e.currentTarget.style.color = linkColor)}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="header-actions" style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <a
            href={contacts.phoneHref}
            className="header-phone"
            style={{
              textDecoration: "none",
              fontFamily: font.display,
              fontWeight: 600,
              fontSize: 16,
              color: dark ? "#fff" : colors.ink,
              whiteSpace: "nowrap",
            }}
          >
            {contacts.phone}
          </a>
          <button
            onClick={openRequest}
            style={{
              background: colors.red,
              color: "#fff",
              border: "none",
              fontFamily: font.display,
              fontWeight: 600,
              fontSize: 12,
              letterSpacing: ".04em",
              textTransform: "uppercase",
              padding: "10px 18px",
              borderRadius: 8,
              cursor: "pointer",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = colors.redDark)}
            onMouseLeave={(e) => (e.currentTarget.style.background = colors.red)}
          >
            Заявка
          </button>

          {/* Бургер — только на мобильном (класс header-burger) */}
          <button
            className="header-burger"
            aria-label="Меню"
            onClick={() => setMenuOpen((v) => !v)}
            style={{
              display: "none",
              width: 42,
              height: 42,
              border: "none",
              borderRadius: 9,
              background: dark ? "rgba(255,255,255,.1)" : "#f1f2f5",
              color: dark ? "#fff" : colors.ink,
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Выпадающее мобильное меню */}
      {menuOpen && (
        <div
          className="header-mobile-menu"
          style={{
            background: dark ? "rgba(13,13,16,.98)" : "rgba(255,255,255,.98)",
            borderTop: dark ? "1px solid rgba(255,255,255,.1)" : "1px solid #e6e9ee",
            padding: "10px 22px 18px",
          }}
        >
          {NAV.map((l) => (
            <a
              key={l.label}
              href={"/#" + l.id}
              onClick={goToSection(l.id)}
              style={{
                display: "block",
                padding: "14px 0",
                textDecoration: "none",
                fontFamily: font.display,
                fontWeight: 600,
                fontSize: 16,
                letterSpacing: ".03em",
                textTransform: "uppercase",
                color: dark ? "#e7e9ec" : colors.ink,
                borderBottom: dark ? "1px solid rgba(255,255,255,.08)" : "1px solid #eef0f3",
              }}
            >
              {l.label}
            </a>
          ))}
          <a
            href={contacts.phoneHref}
            style={{
              display: "block",
              marginTop: 14,
              textDecoration: "none",
              fontFamily: font.display,
              fontWeight: 700,
              fontSize: 20,
              color: colors.red,
            }}
          >
            {contacts.phone}
          </a>
        </div>
      )}
    </header>
  );
}
